module.exports = __webpack_public_path__ + "media/snacks/eats-lots-of-snacks-666f56ef.svg";